import AbstractApiService from 'src/services/abstractApiService';
import { DOC2API_URL } from 'pages/APIs';
import type { dynamicObj } from 'src/pages/assets';
export default class UserSupplierGroupMapping extends AbstractApiService {
  public constructor() {
    super({});
  }

  public async getUserSupplierGroupMapping(): Promise<any> {
    return super.get(
      DOC2API_URL + '/supplier_group/user-assignments',
    );
  }

  public async getUserlist(): Promise<any> {
    return super.get(DOC2API_URL + '/users/get_users');
  }

  public async getGroups(): Promise<any> {
    return super.get(DOC2API_URL + '/groups/get_groups');
  }

  public async addUserSupplierGroupMapping(data: any): Promise<any> {
    return super.post(
      DOC2API_URL + '/supplier_group/user-assignments',
      data,
    );
  }

  public async deleteUserSupplierGroupMapping(data: any): Promise<any> {
    return super.post(
      DOC2API_URL + '/supplier_group/remove-user-assignment',
      data,
    );
  }
}
